/** Optimistic “user canceled” until billing API exists or server returns canceled status. */
export const EFAX_USER_CANCELED_SESSION_KEY = 'klarity_efax_user_canceled';

/**
 * After Stripe unified pay succeeds, status may not yet include `activeAccount` until the number is provisioned.
 * Persist so refresh still shows the setup flow (Figma post-checkout) until `/fax/number/status` returns a number.
 */
export const EFAX_PAY_PENDING_SETUP_KEY = 'klarity_efax_pay_pending_setup';

/** Provider fax subscription status from schedule-server / profile APIs (string casing may vary). */
export function isEfaxSubscriptionCanceledStatus(status: string | undefined | null): boolean {
    if (!status) return false;
    const u = status.toUpperCase();
    return ['CANCELED', 'CANCELLED', 'INACTIVE', 'SUSPENDED', 'EXPIRED'].includes(u);
}
